import { useIdentity } from '../../lib/identity';
import AdultHome from './AdultHome';
import KidHome from './KidHome';

/**
 * The hub — the first thing the family sees every day, and per PRD 6 the one
 * screen where the design goes bold.
 *
 * The two views are separate components rather than one component full of
 * `role === 'adult' &&` branches, so it is impossible for a money card to leak
 * into the kid view by accident: the kid tree never imports one and never calls
 * an adult-only endpoint.
 */
export default function HomePage() {
  const identity = useIdentity();

  return identity.role === 'adult' ? (
    <AdultHome identity={identity} />
  ) : (
    <KidHome identity={identity} />
  );
}
